import { render, staticRenderFns } from "./CompCheckBoxButton.vue?vue&type=template&id=667a9338&"
import script from "./CompCheckBoxButton.vue?vue&type=script&lang=ts&"
export * from "./CompCheckBoxButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports